/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.string().uuid(),
  createdAt: z.number(),
  updatedAt: z.number(),
  carry_out_id: z.string().uuid(),
  preparer_user_id: z.string().uuid(),
  optional_1: z.string(),
  optional_2: z.number(),
  optional_3: z.number(),
  material_count: z.number(),
  deleted_at: z.number().nullable(),
  shipped_at: z.number().nullable(),
  optional_4: z.number(),
  material_id: z.number().nullable(),
  lot_no: z.string().nullable(),
  manufactured_at: z.number().nullable(),
  planned_count: z.number(),
  remarks: z.string().nullable(),
  created_by_user_id: z.string().uuid(),
});
const create = base.extend({
  material_id: base.shape.material_id.optional(),
  lot_no: base.shape.lot_no.optional(),
  manufactured_at: base.shape.manufactured_at.optional(),
  planned_count: base.shape.planned_count.optional(),
  remarks: base.shape.remarks.optional(),
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  shipped_at: true,
  created_by_user_id: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  preparer_user_id: true,
  deleted_at: true,
  shipped_at: true,
  created_by_user_id: true,
})
.extend({ id: z.string().uuid() });
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
  preparer_user_id: true,
  created_by_user_id: true,
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const LotBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type LotBase = z.infer<typeof base>;
export type LotBasePutPayload = z.infer<typeof put>;
export type LotBasePatchPayload = z.infer<typeof patch>;
export type LotBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type LotBaseCreateAttributes = z.infer<typeof create>;
export type LotBaseUpdateAttributes = z.infer<typeof update>;
export type LotBaseCacheAttributes = z.infer<typeof cache>;
export type LotBaseCachesAttributes = z.infer<typeof caches>;